import { css } from 'lit';

export const projectIndexViewStyles = css`

  :host {
    background: linear-gradient(180deg, var(--gray-0) 0, var(--gray-3) 50vh);
  }

  view-content {
    padding-top: 2rem;
    max-width: none;
  }
  @media (min-width: 650px) {
    view-content {
      padding-top: 3.5rem;
    }
  }
  @media (min-width: 1000px) {
    view-content {
      padding-top: 4.5em;
    }
  }

  header-bar {
    row-gap: 0;
    
    --header-prefix-font-size: 1.1rem;

    --header-icon-color: var(--gray-4);
    --header-icon-opacity: 0.5;
    --header-icon-bottom-position: -3rem;
    --header-bar-padding-trim: 5.5rem;
  }
  header-bar button-bar {
    margin-bottom: 2rem;
  }

  #projects-list {
    display: grid;
    position: relative;
    min-height: 7rem;
    margin: var(--view-item-spacing) 0;
    
    grid-template-columns: repeat(auto-fill, minmax(calc(min(25rem, 60vw)), 1fr));
    gap: 1rem;
  }
  @media (min-width: 650px) {
    #projects-list {
      gap: 1.5rem;
    } 
  }
  @media (min-width: 1000px) {
    #projects-list {
      gap: 2rem;
    } 
  }
  @media (min-width: 1500px) {
    #projects-list {
      gap: 2.5rem;
    } 
  }

  #projects-list empty-alert {
    grid-column: 1 / -1;
    border-radius: 0;
    justify-content: center;
  }

  .list-header-bar,
  .list-footer-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
  }

  .list-header-bar {
    justify-content: space-between;
  }

  .list-header-bar sl-button sl-spinner {
    --indicator-color: var(--teal-6);
    --track-color: var(--teal-1);
  }

  .list-header-bar sl-button:hover:not([disabled])::part(base) {
    background-color: var(--teal-0);
    border-color: var(--teal-3);
    color: var(--teal-7);
  }

  .list-header-bar filter-bar {
    justify-content: flex-start;
    align-items: center;
    flex: 1 1 auto;
  }

  .list-header-bar filter-bar .label {
    font-size: 0.9rem;
    color: var(--gray-6);
    font-weight: 500;
  }

  .list-header-bar button-bar {
    justify-content: flex-end;
    align-items: center;
    flex: 1 1 auto;
  }

  .list-header-bar button-bar .timestamp {
    font-size: 0.9rem;
    font-style: italic;
    color: var(--gray-6);
    font-weight: 300;
  }

  .list-footer-bar {
    justify-content: flex-end;
    border-top: 1px solid var(--gray-4);
    padding-top: 1.5rem;
    
    color: var(--gray-6);
    font-weight: 300;
    font-style: italic;
  }

  sl-radio-button::part(button) {
    background: var(--gray-0);
  }
  sl-radio-button::part(button--checked) {
    border-color: var(--gray-3);
    background: var(--gray-4);
    color: var(--gray-8);
  }
  sl-radio-button::part(button):hover,
  sl-radio-button::part(button):focus {
    border-color: var(--gray-3);
    background-color: var(--gray-3);
    color: var(--gray-8);
  }

  sl-dialog p.hero {
    margin-top: 0;
  }

`;
